import { isFunction, each, getResolution, isMobileResolution, getUrlAddCategoryIdByArticle } from '../../utils/util';
import { BREAKPOINTS } from '../../model/model';

class ServerMasterNewArticle {
  constructor(options) {
    const _ = this;

    _.option = $.extend({
      wrap: null,
      data: null,
      breakpoint: BREAKPOINTS,
      global: window
    }, options);

    _.global = _.option.global;

    _.data = _.option.data;

    _.wrap = $(_.option.wrap);
    _.device = _.option.device;

    _.articleWrap = ( _.device === 'pc' || _.device === 'launcher') ?  $('.article-list', _.wrap) : $('.wrap-section-servermaster');

    _.currentResolution = '';

    _.const = {
      NUM_LIST_PER_SECTION_IN_NEW_ARTICLE: 6
    };
  }

  init() {
    const _ = this;

    /* TEST  _.setNewArticleExtendBtn(); */

    if( _.device === 'pc' || _.device === 'launcher') {
      _.setTpl();
      if ($('> ul', _.articleWrap).length <= 1 || !isFunction(_.articleWrap.slick)) return;
    } else {
      _.setMobileTpl();
      if ($('> section', _.articleWrap).length <= 1 || !isFunction(_.articleWrap.slick)) return;
    }


    _.currentResolution = getResolution(_.option.breakpoint, _.global);

    if (!isMobileResolution(_.currentResolution)) {
      // pc/max resolution
      _.setServermasterArticlesSlick(_.articleWrap);
    }

    $(_.global).on('resize', $.proxy(_.resize, _));
    _.resize();
  }

  /* TEST
  setNewArticleExtendBtn() {
    const _ = this;

    $('.btn-extend', _.servermasterWrap).on('click', function (evt) {
      $(this).toggleClass("extend");

      _.articleWrap.toggleClass("extend");
    });
  }
  */

  setTpl() {
    const _ = this,
        sectionNum = Math.ceil(_.data.contentList.length / _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE);

    let index = 0, articles, $tpl, diff, newIconTpl, url;
    for (let i = 0, max = sectionNum; i < max; i++) {
      articles = _.data.contentList.slice(index, _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE * (i + 1));

      $tpl = $('<ul>');

      // set new servermaster articles
      each(articles, function (article) {
        diff = new Date(_.global.userData.now).getTime() - new Date(article.postDate).getTime();
        newIconTpl = (diff < _.const.MILLISECOND_TO_DAY) ? ' <i class="fe-icon-new"></i> ' : '';

        /*url = (article.url || '').split('/').pop() || '#';
        url = getUrlAddCategoryIdByArticle(url, article, _.global._serverNameMap);*/
        url = `view?categoryId=${article.categoryBoard.id}&articleId=${article.id}`;

        $tpl.append(`<li><a class="title" href="${url}">${article.title}${newIconTpl}</a><span class="writer">${article.writer.gameUser.gameCharacterName}</span></li>`);
      });

      _.articleWrap.append($tpl);

      index = _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE * (i + 1);
    }
  }

  setMobileTpl() {
    const _ = this,
        sectionNum = Math.ceil(_.data.contentList.length / _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE);


    let index = 0, articles, $tpl, diff, newIconTpl, url, $tpl_parent;
    for (let i = 0, max = sectionNum; i < max; i++) {
      articles = _.data.contentList.slice(index, _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE * (i + 1));

      $tpl_parent = $(`
    <section class="section-servermaster">
          <header><h3>전체 서버지기 최신기사</h3></header>
      <article class="article-list">
          <ul></ul></article>
          </section>
          `);

      $tpl = $('<ul>');

      // set new servermaster articles
      each(articles, function (article) {
        diff = new Date(_.global.userData.now).getTime() - new Date(article.postDate).getTime();
        newIconTpl = (diff < _.const.MILLISECOND_TO_DAY) ? ' <i class="fe-icon-new"></i> ' : '';

        /*url = (article.url || '').split('/').pop() || '#';
        url = getUrlAddCategoryIdByArticle(url, article, _.global._serverNameMap);*/
        url = `view?categoryId=${article.categoryBoard.id}&articleId=${article.id}`;

        $tpl_parent.find('.article-list ul').append(`<li><a class="title" href="${url}">${article.title}${newIconTpl}</a><span class="writer">${article.writer.gameUser.gameCharacterName}</span></li>`);
      });


      /* TEST
       _.articleWrap.append($tpl);
      */
      $(".wrap-section-servermaster").append($tpl_parent);


      index = _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE * (i + 1);
    }
  }


  setServermasterArticlesSlick($wrap) {
    if (this.isSlickWrapInitialized($wrap)) return;

    $wrap.slick({
      dots: true,
      speed: 250,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000
    });
  }

  resize(evt) {
    const _ = this,
        resolution = getResolution(_.option.breakpoint, _.global),
        isSlickInitialized = _.isSlickWrapInitialized(_.articleWrap);

    if (isSlickInitialized) _.articleWrap.slick('resize');

    _.setServermasterArticlesSlick(_.articleWrap);

    /* TEST
    if (resolution !== _.currentResolution) {
      const isCurrentMobileRes = isMobileResolution(_.currentResolution),
          isMobileRes = isMobileResolution(resolution);

      if (isCurrentMobileRes && !isMobileRes) {
        // change phone/tablet to pc/max
        _.setServermasterArticlesSlick(_.articleWrap);

      } else if (!isCurrentMobileRes && isMobileRes) {
        // change pc/max to phone/tablet
        // 06 if (isSlickInitialized) _.articleWrap.slick('unslick');

      }
    }
    _.currentResolution = resolution;
    */


  }

  isSlickWrapInitialized($wrap) {
    if ($wrap.length) return $wrap.hasClass('slick-initialized');

    return false;
  }
}

export default ServerMasterNewArticle;


// WEBPACK FOOTER //
// ./_src/js/board/servermaster/ServerMasterNewArticle.js